import { FormattedMessage } from 'react-intl';
import Button from '@alltrails/denali/components/Button';
import { PaymentOptionValues } from '../RadioPaymentForm/PaymentOptions';
import styles from './TogglePaymentButton.module.scss';

export default function TogglePaymentButton({
  selectedPaymentType,
  setSelectedPaymentType
}: {
  selectedPaymentType: PaymentOptionValues | undefined;
  setSelectedPaymentType: (paymentType: PaymentOptionValues) => void;
}) {
  const isCreditCardSelected = selectedPaymentType === PaymentOptionValues.CreditCard;

  const handleClick = (e?: React.MouseEvent) => {
    e?.preventDefault();
    setSelectedPaymentType(isCreditCardSelected ? PaymentOptionValues.Apple : PaymentOptionValues.CreditCard);
  };

  return (
    <Button
      width="full"
      onClick={handleClick}
      text={
        isCreditCardSelected ? (
          <div className={styles.applePayButton}>
            <FormattedMessage defaultMessage="Continue with" />
            &nbsp;
            <span className={styles.logo}>
              <span />
            </span>
          </div>
        ) : (
          <FormattedMessage defaultMessage="Pay with card" />
        )
      }
      type="submit"
      variant="ghost"
    />
  );
}
